import { createAsyncThunk } from '@reduxjs/toolkit';
import { productAdminRolesApi } from '@/services/api';
import { ProductAdminRole as ApiProductAdminRole } from '@/services/api/productAdminRoles';
import i18n from '@/settings/i18n';
import { sentryReportError } from '@/utils/sentryReportError';
import { ProductAdminRole } from './slice';

type FetchRolesParams = {
  organizationId: number;
};

export const fetchRoles = createAsyncThunk(
  'productAdminRole/fetchRoles',
  async ({ organizationId }: FetchRolesParams) => {
    try {
      const params = { params: { lang: i18n.languages[0] } };
      const response = await productAdminRolesApi.getProductAdminRoles(
        organizationId,
        params,
      );

      // APIレスポンスをProductAdminRole型に変換
      const roles: ProductAdminRole[] = response.productAdminRoles
        ? response.productAdminRoles.map((productAdminRole: ApiProductAdminRole) => ({
            productName: productAdminRole.productName,
            role: productAdminRole.role,
            helpUrl: productAdminRole.helpUrl,
          }))
        : [];

      return roles;
    } catch (error) {
      // glopla_apiへのAPI実行に失敗すると、ここに到達します。
      // glopla_api内部で各サービスへのAPI実行に失敗すると、ここには到達せず role にエラーメッセージが含まれる仕様です。
      sentryReportError(error);
      throw error;
    }
  },
);
